import React from 'react'
import Info from '@blocks/Info'
import { ReactComponent as ProgressStarIcon } from '@icons/progress_star.svg'

export default function SalonVotingStatus() {
    return <Info label="Voting" icon={<ProgressStarIcon />} />
}